import axios from 'axios';

export const workflowThreeApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/workflow-three`,
    headers: {
        'Content-Type': 'application/json'
    }
})